import {
  h,
  Component
} from 'preact';

/**
 * @extends {Component<import("../shared-types").QuestionComponentProps>}
 */
class BaseComponent extends Component {
  componentDidMount() {
    this.props.didRender();
  }

  omittedPlaceholder() {
    return h("div", {
      class: "response-collector student-omitted"
    }, "No response submitted");
  }

  wrapper() {
    return h("div", {
      class: "question-wrapper",
      "data-question-id": this.props.item.id,
    }, ...arguments)
  }

  body() {
    if(!this.props.showBody) {return null};

    return h("div", {
      class: "question-body",
      id: `question-body-${this.props.item.id}`,
      dangerouslySetInnerHTML: {
        __html: this.props.item.bodyWithSubstitutions || this.props.item.body
      }
    })
  }

  render() {
    return h("p", {}, "component missing for item");
  }

  round(float) {
    var parts = float.toString().split('.');
    if (parts.length > 1) {
      var decimal = parseFloat(parts[0] + '.' + parts[1]).toFixed(Math.min(2, parts[1].length));
      float = parseFloat(decimal.toString().replace(/0+$/gm, ""));
    }
    return float;
  }
}

export default BaseComponent;